import { useNavigate, useSearchParams } from 'react-router-dom'
import InterviewScheduleModal from '@/components/interview/InterviewScheduleModal'

export default function ScheduleInterviewPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const candidateId = searchParams.get('candidateId') || undefined
  const candidateName = searchParams.get('candidateName') || undefined
  const positionId = searchParams.get('positionId') || undefined

  return (
    <div className="py-2">
      <InterviewScheduleModal
        open
        variant="page"
        onClose={() => navigate('/recruiter/interviews')}
        candidateId={candidateId}
        candidateName={candidateName}
        positionId={positionId}
      />
    </div>
  )
}
